let activeLocks = 0
const BODY_SCROLL_LOCK_CLASS = 'wikibit-body-scroll-locked'

/**
 * 使用 body 样式类锁定背景滚动，同时保留 html 根滚动容器以兼容 sticky 导航。
 * 多个弹窗重叠时，通过计数避免其中一个关闭后提前解锁。
 */
export const useStickyDialogScrollLock = () => {
  let isLocked = false

  /** 锁定当前弹窗外的背景页面滚动。 */
  const lock = () => {
    if (!import.meta.client || isLocked) {
      return
    }

    if (activeLocks === 0) {
      document.body.classList.add(BODY_SCROLL_LOCK_CLASS)
    }

    activeLocks += 1
    isLocked = true
  }

  /** 释放当前弹窗的背景滚动锁。 */
  const unlock = () => {
    if (!import.meta.client || !isLocked) {
      return
    }

    activeLocks -= 1
    isLocked = false

    if (activeLocks === 0) {
      document.body.classList.remove(BODY_SCROLL_LOCK_CLASS)
    }
  }

  return { lock, unlock }
}
